import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { Redirect } from 'react-router-dom'

const Consulta = () => {
    return (
        <>
            {sessionStorage.login
            ?
                <div className="listado" id="menu">
                    <h2 className='tituloAccion'>Consultas</h2>
                    <TableContainer style={{marginBottom: '2rem'}}>
                        <Table sx={{minWidth: 500}} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell><a href="./Consultas-Movimientos">Movimientos</a></TableCell>
                                    <TableCell><a href="./Consultas-ControlAsistencia">Control de Asistencia</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-SaldoFuncionario">Saldos Funcionario</a></TableCell>
                                    <TableCell><a href="./Consultas-Funcionario">Funcionario</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-OmisionesFuncionario">Omisiones Funcionario</a></TableCell>
                                    <TableCell><a href="./Consultas-MarcasManual">Marcas Manual</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-SalidasEntreHorario">Salidas Entre Horario</a></TableCell>
                                    <TableCell><a href="./Consultas-HoraSimplesExtras">Listado de Días y Horas</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-ControlAsistenciaConfirmadas">Control Asistencia Confirmada</a></TableCell>
                                    <TableCell><a href="./Consultas-Calificaciones">Calificaciones Funcionarios</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-MarcasRelojesMensual">Marcas Relojes</a></TableCell>
                                    <TableCell><a href="./Consultas-MarcasRelojesMensualPlanilla">Marcas Mensual (Planilla)</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-Informes">Informes</a></TableCell>
                                    <TableCell><a href="./Consultas-InformesCalificaciones">Informe Calificaciones</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-NivelEducativo">Nivel Educativo</a></TableCell>
                                    <TableCell><a href="./Consultas-DescuentosDiariosManuales">Descuentos Diarios Manuales</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="./Consultas-Jornaleros">Jornaleros</a></TableCell>
                                    <TableCell><a href="./Consultas-Medicos">Medicos</a></TableCell>
                                </TableRow>
                                <TableRow>
                                {sessionStorage.numeroFuncionarioAsociado === '11112' ? <TableCell><a href="./Consultas-Ranking">Ranking</a></TableCell> : null}
                                </TableRow>
                                {/*<TableRow>
                                    <TableCell><a href="../Consultas/ResumenMovCodigo">Resúmen Movimientos por Código</a></TableCell>
                                    <TableCell><a href="../Consultas/HorasPendientes">Horas y Días Inhábiles Pendientes</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="../Consultas/LicenciaReglamentaria">Informe Licencias Reglamentarias</a></TableCell>
                                    <TableCell><a href="../Consultas/MarcadaFuncionamieno">Marcada por Funcionamiento por Día</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="../Consultas/RepeticionEnfermedades">Repetición de Enfermedades en el Año</a></TableCell>
                                    <TableCell><a href="../Consultas/ListadoPrima">Listado de Prima por Asiduidad</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="../Consultas/ListadoLicenciaPendiente">Listado de Licencia Pendiente</a></TableCell>
                                    <TableCell><a href="../Consultas/ListadoAntiguedad">Listado de Antigüedad Pendiente</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="../Consultas/ListadoAsuetos">Listado de Asueto Pendiente</a></TableCell>
                                    <TableCell><a href="../Consultas/ListadoEnfermedades">Listado Enfermedades Anual</a></TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell><a href="../Consultas/LicenciaAnual">Listadode Licencia Anual</a></TableCell>
                                    <TableCell><a href="../Consultas/BorrarRepetidos">Borrar Repetidos</a></TableCell>
                                </TableRow>*/}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            :
                <Redirect to='/login'/>
            }
        </>
    )
}

export default Consulta